package com.macrofocus.eflux

import com.macrofocus.common.properties.SimpleProperty
import com.macrofocus.eflux.diagram.DiagramType
import com.macrofocus.eflux.time.EFluxTimeTracker
import korlibs.time.hours
import kotlinx.browser.window
import kotlin.js.Promise

class EFlux {
    val earliest: Promise<String> = Promise.resolve(window.fetch("/db/earliest").then { response ->
        response.text()
    }.then {
        it
    })
    val latest: Promise<String> = Promise.resolve(window.fetch("/db/latest").then { response ->
        response.text()
    }.then {
        it
    })

    val showAbout = SimpleProperty(false)
    val showSearch = SimpleProperty(true)
    val showClock = SimpleProperty(false)

    // Info
    val nodeTab = SimpleProperty("lines")
    val linkTab = SimpleProperty("assets")
    val riskTab = SimpleProperty("lines")
    val coordinateTab = SimpleProperty("lines")

    val showTable = SimpleProperty(false)
    val diagramTypeProperty = SimpleProperty(DiagramType.ThreeD)
    val configuration = EFluxConfiguration(earliest, latest, EFluxTimeTracker("20250101_0000".toDateTime(), null, 24.hours)
    )

    init {
        println("Initializing EFlux")
//        configuration.viewStyle.value = ViewStyle.FLOW
//        configuration.colorNodes.value = null
//        configuration.tooltipNodes.value = arrayOf(NodeField.v)
//        configuration.tooltips.value = false
//        configuration.tooltipLinks.value = arrayOf(LinkField.p, LinkField.pratea)
//        configuration.heatmapLinks.value = null
//        configuration.cities.value = true
    }

    val dataLoader = DataLoader(earliest, latest, diagramTypeProperty, configuration)

    init {
        configuration.timeTracker.reset = { dataLoader.diagramLoaders[0].svgPanZoomContext.value?.reset() }
    }
}